import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type ReportDocument } from 'types/models';

export interface ReportDocumentsState extends EntityState<ReportDocument>, ActiveState {}

const store = createEntityStore<ReportDocumentsState>({}, { resettable: true, name: 'reportDocuments' });

export default store;
